import { render, staticRenderFns } from "./projectFlow.vue?vue&type=template&id=5a1113d6"
import script from "./projectFlow.vue?vue&type=script&lang=js"
export * from "./projectFlow.vue?vue&type=script&lang=js"
import style0 from "./projectFlow.vue?vue&type=style&index=0&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports